// extracted by mini-css-extract-plugin
module.exports = {"root":"TeamsBlock_root__uDqcL","title":"TeamsBlock_title__BUReo"};